import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from './components/HomePage/HomePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Menu } from './components/Menu/Menu';
import { About } from './components/About/About';

function App() {
  return (
    <>
      <Navbar className="myNav" bg="light" expand="lg">
        <Container style={{maxWidth: "100%", padding: "0 5% 0 5%", margin: 0}}>
            <Navbar.Brand href="/">
              <img src="/saucelogo.svg" alt="logo" style={{height: '50px'}} />
            </Navbar.Brand>
            <Navbar.Text className="cooperl" style={{color: "black"}}>(570) 994-4134</Navbar.Text>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
              <Nav className="justify-content-end aqum">
                  {/* <Nav.Link href="#gift">Weekly Specials</Nav.Link> */}
                  <Nav.Link className="cooperl" style={{color: "black"}} href="/about">About</Nav.Link>
                  <span className="web-only" style={{alignSelf: "center"}}>|</span>
                  <Nav.Link className="cooperl" style={{color: "black"}} href="/menu">Menu</Nav.Link>
                  {/* <Nav.Link href="#catering">Contact Us</Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
      </Container>
      </Navbar>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/about" element={<About />} />
          {/* <Route path="/catering" element={<Menu />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
